import React, { useState } from "react";
import "./Roofrepair.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Types_of_bituminous_sheets() {



  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>      סוגי יריעות ביטומניות  </h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
   <Link to="/Bituminoussheets">   יריעות ביטומניות</Link>/{" "}
    <Link to="/Types_of_bituminous_sheets">  סוגי יריעות ביטומניות  </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">

    <h2 className="top-text">
סוגי היריעות שמשתמשים בהן כיום בעולם האיטום, הן יריעות איטום ביטומניות. לכן, אנו נסקור במאמר זה, סוגי יריעות ביטומניות שונות. אנו נסביר מהו השימוש המתאים ביותר לכל סוג יריעה. אנו נסקור יריעות המתאימות לחיפוי גגות, יריעות המתאימות לחיפוי קירות, ויריעות שמיועדות לחניונים, ומקומות עם עצים הצומחים ליד. אנו נסקור גם ציפויים שונים של יריעות ביטומניות, כגון חיפוי של רדיד אלומניום, או חיפוי של לבד זכוכית.    </h2>
    <div className="content-row">

      <div className="image-box">
        <img src="/images/62.jpg" alt="roof" />
      </div>
      <div className="text-box">



    <h2 className="main-title">
יריעות ביטומניות לחיפוי קירות:


    </h2>
        <p>         בבניינים ישנים, איכות הקיר החיצוני, אינה טובה. פעמים רבות, תחדור רטיבות דרך הקיר החיצוני. אולם, כאשר מחפים קיר ביריעת איטום ביטומנית, יש צורך ביריעת איטום דקה יותר. לכן, פותחו יריעות איטום ביטומניות מיוחדות עבור קירות. יריעות אלו עבות פחות מיריעות האיטום הביטומניות הרגילות. בדרך כלל, מומלץ למרוח חומר איטום על פני הקיר, לפני שמצמידים את היריעות לקיר. יריעות אלו מצופות באבקת הזכוכית. הזכוכית, נותנת ליריעה הגנה מירבית מפני רטיבות, ונזקים אחרים.           </p>



      </div>




    </div>

    <h2 className="main-title">
סוגים שונים של יריעות ביטומניות אלסטיות:


    </h2>

    <div className="bottom-text">
      <p>אנו נסקור 2 סוגי יריעות ביטומניות אלסטיות. יריעות איטום אלסטיות, מתאימות לאיטום גגות בתנאים קשים יותר. כמו למשל- איטום שטח מתחת לגגות העשויות מחומר אזבסט, או מרעפים. יריעות אלו, נוחות מאוד לעבודת איטום המתבצעת על גג בטון, כמו למשל איטום גגות מקלטים. </p>

    <h2 className="main-title">
יריעות איטום ביטומניות המצופות באלומיניום:


    </h2>

      <p>לפעמים, יש צורך בחיפוי נוסף על יריעות האיטום, מלבד חומר הזכוכית. לשם כך, פותחו יריעות מיוחדות, המכילות גם ציפוי של רדיד אלומיניום. חומר האלומיניום, יוצר חסימה מפני מעבר אדים היוצר לחות ואף רטיבות, ויכול אף לשמש חסימה מפני רעש. יריעות אלו מתאימות למפעלים, או מקומות בהן נוצר רעש מכל קול של הד. סוג זה של יריעות, מתאים פחות לגגות, ומותאם לחיפוי רצפות וקירות במבנים סגורים.</p>

    <h2 className="main-title">
שימוש ביריעות ביטומניות:



    </h2>

      <p> חברת "איטומים בגבהים", משתמשת במספר סוגים של יריעות איטום ביטומניות. אנו נסקור מספר סוגי יריעות ביטומניות:
</p>

    <h2 className="main-title">
יריעות המתבססות על פולימרים:


    </h2>

      <p>אנו משתמשים ב- 2 סוגים של יריעות איטום לגג המבוססות על פולימר. סוג אחד הוא יריעות המכילות פולימר APP. סוג אחר, הוא יריעות SBS.
חברת "איטומים בגבהים", משתמשת ביריעות איטום ביטומניות, אשר שורש עץ לא יכול לחדור אל היריעה ולקרוע. לחברה יש יריעות נגד חדירת שורשים ללא פולימרים, ו2 סוגים נוספים של יריעות נגד שורשים: יריעות לא חדירות, המכילות פולימר APP, ויריעות לא חדירות המכילות פולימר SBS.</p>




    </div>


     <ContactSection2/>
<div className="links">

  <Link to="/Roofwaterproofingsheets" className="link-right" >יריעות איטום לגג </Link>
  <Link to="/Hot_tar" className="link-left" > זפת חם  </Link>

</div>

      </div>
    </div>
  

      </div>
  );
}

